import React, { Fragment, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom"



const Header = ({ menuToggle, setMenuToggle }) => {
    // const [menuToggle, setMenuToggle] = useState(false);
    const navigate = useNavigate();

    const menu = [
        {
            title: '方案價格',
            path: '/pricing'
        }, {
            title: '使用手冊',
            path: 'https://revx.gitbook.io/guide-book/'
        }, {
            title: '付款方式',
            path: '/pay'
        }, {
            title: '免費註冊',
            path: '/user-flow'
        }
    ]
    useEffect(() => {

    }, [])
    return (
        <nav>
            <div className="revx-logo cursor-pointer" onClick={() => navigate('/')}>
                <img src={process.env.PUBLIC_URL + '/img/logo/revX-logo-white.png'} alt='revx logo' />
            </div>

            <div className="nav-bar">
                <div className="nav-bar-wrapper flex">
                    {
                        menu.map((item, index) => {
                            return (
                                <Fragment key={index}>
                                    {
                                        item.path.includes('http')
                                            ?
                                            <Link to={item.path} className="hidden sm:block m-2 hover:text-teal-300" target="_blank" rel="noreffer">{item.title}</Link>
                                            :
                                            <Link to={item.path} className="hidden sm:block m-2 hover:text-teal-300">{item.title}</Link>
                                    }
                                </Fragment>
                            )
                        })
                    }
                </div>

                <div className="menu-wrapper sm:hidden">
                    <div className="menu p-3" onClick={() => { setMenuToggle(!menuToggle) }}>
                        {!menuToggle ? 'Menu' : 'Close'}
                        <div
                            className={`hamburger ms-3 ${menuToggle && 'active'}`}
                        >
                            <span className="up"></span>
                            <span className="mid"></span>
                            <span className="down"></span>
                        </div>
                    </div>

                    <ul
                        className={`${menuToggle && 'active'}`}
                    >
                        {
                            menu.map((item, index) => {
                                return (
                                    <Fragment key={index}>
                                        {
                                            item.path.includes('http')
                                                ?
                                                <li key={index}
                                                    className="p-3 ">
                                                    <Link to={item.path} target="_blank" rel="noreffer">
                                                        {item.title}
                                                    </Link>
                                                </li>
                                                :
                                                <li key={index}
                                                    className="p-3 "
                                                    onClick={() => navigate(item.path)}>
                                                    {item.title}
                                                </li>
                                        }
                                    </Fragment>


                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </nav>
        // <nav class="navbar navbar-expand-lg ">
        //     <div class="container-fluid ">
        //         <a class="navbar-brand" href="/">
        //             <img src={process.env.PUBLIC_URL + '/img/logo/revX-logo-white.png'} alt='revx logo' />
        //         </a>
        //         <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        //             <span class="navbar-toggler-icon"></span>
        //         </button>
        //         <div class="collapse navbar-collapse" id="navbarSupportedContent">
        //             <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-flex">
        //                 {/* <li class="nav-item">
        //                     <a class="nav-link active" aria-current="page" href="#" >Home</a>
        //                 </li> */}
        //                 <li class="nav-item">
        //                     <a class="nav-link" href="#">Sign up for free</a>
        //                 </li>
        //                 <li class="nav-item dropdown">
        //                     <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
        //                         Dropdown
        //                     </a>
        //                     <ul class="dropdown-menu  ">
        //                         <li><a class="dropdown-item" href="#">Action</a></li>
        //                         <li><a class="dropdown-item" href="#">Another action</a></li>
        //                         <li><hr class="dropdown-divider" /></li>
        //                         <li><a class="dropdown-item" href="#">Something else here</a></li>
        //                     </ul>
        //                 </li>
        //                 {/* <li class="nav-item">
        //                     <a class="nav-link disabled" aria-disabled="true">Disabled</a>
        //                 </li> */}
        //             </ul>
        //             {/* <form class="d-flex" role="search">
        //                 <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
        //                 <button class="btn btn-outline-success" type="submit">Search</button>
        //             </form> */}
        //         </div>
        //     </div>
        // </nav >
    )
}

export default Header;